<li
  role="separator"
  aria-hidden="true"
  class={colorClassNames.primary}
  in:fly={{ delayMultiplier: index }}
/>

<style lang="less">
  li {
    background: currentColor;
    display: inline-block;
    height: 16px;
    width: 1px;
    margin: auto 17px;
  }

  @media (max-width: @breakpoint-tablet - 1) {
    li {
      height: 2px;
      width: 20px;
      margin: 18px 0 40px;
    }
  }
</style>

<script>
  import { fly } from '../../../lib/animation';

  export let index = 0;
  export let colorClassNames;
</script>
